export default function TrustSection() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="font-heading text-sm uppercase tracking-[0.2em] text-accent-600 mb-3">Trusted by Shoppers</p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            <span className="italic text-primary-600">10,000+</span> Curated Finds
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 max-w-xl mx-auto">
            Our community-driven spreadsheet resources are trusted by international shoppers worldwide
            for quality, accuracy, and comprehensive coverage.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          <div className="bg-accent-500 rounded-2xl p-8 md:p-10 relative overflow-hidden group cursor-pointer"
            onClick={() => window.open('https://kaspreadsheet.com', '_blank', 'noopener,noreferrer')}
          >
            <div className="relative z-10">
              <span className="font-heading text-6xl md:text-8xl font-black text-white/90">98%</span>
              <p className="text-white/90 text-lg md:text-xl font-semibold mt-4">Satisfaction Rate</p>
              <p className="text-white/70 text-sm mt-2 max-w-xs">
                Community-verified spreadsheet resources trusted by thousands of international shoppers
                for reliable product discovery.
              </p>
            </div>
            <div className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white cursor-pointer">
              <i className="ri-arrow-right-up-line"></i>
            </div>
          </div>

          <div className="bg-secondary-400 rounded-2xl p-8 md:p-10 relative overflow-hidden group cursor-pointer"
            onClick={() => window.open('https://kaspreadsheet.com', '_blank', 'noopener,noreferrer')}
          >
            <div className="relative z-10">
              <span className="font-heading text-6xl md:text-8xl font-black text-foreground-900/80">50+</span>
              <p className="text-foreground-800 text-lg md:text-xl font-semibold mt-4">Expert Guides</p>
              <p className="text-foreground-600 text-sm mt-2 max-w-xs">
                Comprehensive tutorials covering QC methods, shipping strategies, size guides, and smart
                buying techniques for international shoppers.
              </p>
            </div>
            <div className="absolute top-6 right-6 w-10 h-10 rounded-full bg-foreground-900/10 flex items-center justify-center text-foreground-700 cursor-pointer">
              <i className="ri-arrow-right-up-line"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}